export function hasVisibleMessageContent(content: unknown): boolean {
  if (typeof content === "string") return content.trim().length > 0;
  if (!Array.isArray(content)) return false;

  return content.some((part) => {
    if (typeof part === "string") return part.trim().length > 0;
    if (typeof part !== "object" || part === null) return false;

    const typedPart = part as { type?: unknown; text?: unknown };
    if (typedPart.type === "text") {
      return typeof typedPart.text === "string" && typedPart.text.trim().length > 0;
    }

    return typeof typedPart.type === "string";
  });
}
